import React from 'react'
import withIcon from '@/components/withIcon'

const IconDialogBalloon = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 1H2C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H4.5C5.12951 11 5.72229 11.2964 6.1 11.8L8 14.3333L9.9 11.8C10.2777 11.2964 10.8705 11 11.5 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1ZM2 0C0.895431 0 0 0.895431 0 2V10C0 11.1046 0.89543 12 2 12H4.5C4.81476 12 5.11115 12.1482 5.3 12.4L7.2 14.9333C7.6 15.4667 8.4 15.4667 8.8 14.9333L10.7 12.4C10.8889 12.1482 11.1852 12 11.5 12H14C15.1046 12 16 11.1046 16 10V2C16 0.895431 15.1046 0 14 0H2Z"
        fill="#162941"
      />
    </svg>
  )
}

export default withIcon(IconDialogBalloon)
